import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';

export const StackClientListWrapper = styled(Stack)`
  height: 100%;
  margin-top: 16px;
  overflow-y: scroll;
`;
